import { render, staticRenderFns } from "./Ticket.vue?vue&type=template&id=61282acd&scoped=true&"
import script from "./Ticket.vue?vue&type=script&lang=js&"
export * from "./Ticket.vue?vue&type=script&lang=js&"
import style0 from "./Ticket.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Ticket.vue?vue&type=style&index=1&id=61282acd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61282acd",
  null
  
)

export default component.exports